module.exports = __webpack_public_path__ + "img/gcjs.38f69a7.jpg";